module.exports = __webpack_public_path__ + "static/img/Jean-Pascal_Tricoire_2017-18.24c62c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/leadership/Jean-Pascal_Tricoire_2017-18.jpg
// module id = 8ynN
// module chunks = 0